import { render } from "./CompetitionsLegend.vue?vue&type=template&id=78b467e8&scoped=true"
import script from "./CompetitionsLegend.vue?vue&type=script&lang=js"
export * from "./CompetitionsLegend.vue?vue&type=script&lang=js"

import "./CompetitionsLegend.vue?vue&type=style&index=0&id=78b467e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b467e8"]])

export default __exports__